<div class="content-wrapper">
  <admin-navigation-menu [disableNavigationLink]="disableNavigationLink()"></admin-navigation-menu>
  <div class="content">
    <ng-content></ng-content>
  </div>
</div>
